import { render } from "./AlocateUser.vue?vue&type=template&id=4932cd55&scoped=true"
import script from "./AlocateUser.vue?vue&type=script&lang=js"
export * from "./AlocateUser.vue?vue&type=script&lang=js"

import "./AlocateUser.vue?vue&type=style&index=0&id=4932cd55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4932cd55"]])

export default __exports__